import {post, postJson} from '../utils/request'

export default {
    getAll: function (query, pagination) {
        return post("/admin/order/list", {...query, ...pagination});
    },
    updateAmount: function (id, amount) {
        return post("/admin/order/updateAmount", {id, amount});
    },
    deleteById: function (id) {
        return post("/admin/order/del", {id});
    },
}
